













import { useConfigStore } from '@/store/config';
import { checkTimeBetween, getServerTime } from '@/utils/date-helper';
import { computed, defineComponent, toRefs } from '@vue/composition-api';
import ScrollNotice from './common/scroll-notice.vue';
import SvgIcon from '@/components/common/svg-icon.vue';

export default defineComponent({
  name: 'TopScrollNotice',
  props: {},
  components: {
    ScrollNotice,
    SvgIcon,
  },
  setup() {
    const configStore = useConfigStore();
    const { config } = toRefs(configStore);


    const isShow = computed(() => {
      const { startTime, endTime, text } = config.value?.commonConfig?.noticeConfig || {};
      if (!startTime || !endTime || !text) {
        return false;
      }
      // 开始结束时间判断
      return checkTimeBetween({ targetTime: getServerTime(), startDate: startTime, endDate: endTime });
    });

    const text = computed(() => config.value?.commonConfig?.noticeConfig?.text || '');

    return {
      isShow,
      text,
    };
  },
});
